import { cssUtil } from "../utils/cssUtil";
import { getBaseStyles } from "./commonStyles";

export function renderIFrameWidget(context, widget, parent) {

    const device = widget?.properties?.desktop;
    const src = widget?.content;

    if (!src) {
        return;
    }

    // Wrapper
    const element = context.document.createElement("div");
    element.classList.add("widget", "iframe_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = getBaseStyles(widget, breakpoint);
    element.setAttribute("style", cssUtil.toStyleString(styles));

    // Iframe
    const iframe = context.document.createElement("iframe");
    iframe.src = src;

    // Size handling
    if (device?.layout?.width) {
        iframe.style.width = device.layout.width;
    } else {
        iframe.style.width = "100%";
    }

    if (device?.layout?.height) {
        iframe.style.height = device.layout.height;
    } else {
        iframe.style.height = "100%";
    }

    // Safe defaults
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute(
        "sandbox",
        "allow-scripts allow-same-origin allow-forms allow-popups"
    );

    iframe.style.border = "0";
    iframe.style.display = "block";

    element.appendChild(iframe);
    parent.appendChild(element);
}